<template>
    <div v-bind:id="id" class="unlayer-editor" v-bind:style="{ minHeight: minHeight }"></div>
</template>

<script>
import { defineComponent, shallowRef } from 'vue'
import { loadScript } from './loadScript'
let lastEditorId = 0

export default defineComponent({
    name: 'EmailEditor',
    props: {
        editorId: String,
        minHeight: {
            type: String,
            default: '500px',
        },
        options: Object,
        scriptUrl: String,

        /**
         * @Deprecated Props: Use `options.appearance` instead
         */
        appearance: Object,
        /**
        * @Deprecated Props: Use `options.locale` instead
        */
        locale: String,
        /**
        * @Deprecated Props: Use `options.projectId` instead
        */
        projectId: Number,
        /**
        * @Deprecated Props: Use `options.tools` instead
        */
        tools: Object,
    },
    computed: {
        id() {
            return this.editorId || `editor-${++lastEditorId}`
        },
    },
    setup() {
        // shallowRef is used to avoid window.postMessage error
        const editor = shallowRef(null) // Creates a reactive reference

        return {
            editor, // Makes editor available to the template
        }
    },
    mounted() {
        loadScript(this.loadEditor.bind(this), this.scriptUrl)
    },
    methods: {
        loadEditor() {
            const options = this.options || {}

            if (this.appearance) {
                options.appearance = this.appearance
            }

            if (this.locale) {
                options.locale = this.locale
            }

            if (this.projectId) {
                options.projectId = this.projectId
            }

            if (this.tools) {
                options.tools = this.tools
            }

            this.editor = unlayer.createEditor({
                ...options,
                id: this.id,
                source: {
                    name: 'vue-email-editor',
                    version: '2.1.1',
                },
            })

            this.$emit('load')
            this.editor.addEventListener('editor:ready', () => {
                this.$emit('ready')
            })
        },
        /**
         * @deprecated This method will be removed in the next major release. Use `editor.exportHtml` instead.
         */
        exportHtml(callback) {
            this.editor?.exportHtml(callback)
        },
        /**
         * @deprecated This method will be removed in the next major release. Use `editor.loadDesign` instead.
         */
        loadDesign(design) {
            this.editor?.loadDesign(design)
        },
        /**
        * @deprecated This method will be removed in the next major release. Use `editor.saveDesign` instead.
        */
        saveDesign(callback) {
            this.editor?.saveDesign(callback)
        }
    },
})
</script>

<style scoped>
.unlayer-editor {
    flex: 1;
    display: flex;
}
</style>